import { useEffect, Fragment, useState } from "react";

import formatearNumero from "../../helpers/datos/formatearNumero";

const OrdenPagoLista = ({ tramites, catalogos, setAPagar }) => {

    const [total, setTotal] = useState(0);
    const UMA = catalogos?.uma?.valor;

    const obtenerTotal = () => {
        let suma = 0;
        for (let i = 0; i < tramites.length; i++) {
            if(tramites[i].idUnidadCobro !== 1){
                tramites[i].pagoFinal = tramites[i].importe.toFixed(2);
                suma += (tramites[i].importe);
            }
            else{
                tramites[i].pagoFinal = (tramites[i].importe * UMA).toFixed(2);
                suma += (tramites[i].importe * UMA);
            }
        }
        setTotal(suma.toFixed(2));
        setAPagar(suma.toFixed(2));
    }

    const eliminarTramite = (key) => {
        let index;
        for (let i = 0; i < tramites.length; i++) {
            if (tramites[i].key === key) {
                index = i;
                break;
            }
        }
        tramites.splice(index, 1);
        obtenerTotal();
    }

    useEffect(() => obtenerTotal());

    return (

        <div className="contenedorForm grid_5cols">

            <div className="encabezadoForm grid_5cols">Seleccionar</div>
            <div className="encabezadoForm grid_5cols">Ejercicio</div>
            <div className="encabezadoForm grid_5cols">Trámite</div>
            <div className="encabezadoForm grid_5cols">Concepto</div>
            <div className="encabezadoForm grid_5cols">Importe</div>

            {tramites.map(tramite =>
                <Fragment key={tramite.key}>
                    <div className="filaForm actions" onClick={() => eliminarTramite(tramite.key)}><button><span className="material-icons">
                        disabled_by_default
                    </span></button></div>

                    <div className="filaForm">{String(tramite.ejercicio).toUpperCase()}</div>

                    <div className="filaForm" title={tramite.tramite.toUpperCase()}>
                        {tramite.tramite.toUpperCase()}

                    </div>

                    <div className="filaForm" title={tramite.concepto.toUpperCase()}>
                        {tramite.concepto.toUpperCase()}
                    </div>

                    <div className="filaForm">${formatearNumero(`${tramite.pagoFinal}`)}</div>
                </Fragment>
            )}

            <div className="totalForm">Total $</div>
            <div className="importeForm">{formatearNumero(`${total}`)}</div>

        </div>
    );
}

export default OrdenPagoLista;